import {mapActions} from "vuex";
import rateSelect from "@/components/features/rate-select/index.vue";

export default {
    name: "LessonRate",
    props: {
        lesson: {
            required: true,
            type	: Object
        }
    },
    components: {
        rateSelect,
    },
    mounted() {
		//console.log('mounted:');
		//console.log(this.lesson);
		//console.log('');
	},
	created() {
		//console.log('created:');
		//console.log(this.lesson);
		//console.log('');
	},
    computed: {
		isShow(){
			return true;
		},
        hasCreatedRate() {
            return !Array.isArray(this.lesson.userRating.data)
        },
        value() {
            return this.hasCreatedRate ? this.lesson.userRating.data.rating : null;
        },
        summary() {
            return this.lesson.ratingSummary.data;
        }
    },
    methods: {
        ...mapActions({
            createLessonRate: 'coursesLesson/CREATE_LESSON_RATE',
            updateLessonRate: 'coursesLesson/UPDATE_LESSON_RATE'
        }),
        async onValueChanged(rating) {
            try {
                if (this.hasCreatedRate) {
                    await this.updateLessonRate({
                        item: this.$route.params.item,
                        moduleSlug: this.$route.params.moduleSlug,
                        slug: this.lesson.slug,
                        rateId: this.lesson.userRating.data.id,
                        rating
                    })
                } else {
                    await this.createLessonRate({
                        item: this.$route.params.item,
                        moduleSlug: this.$route.params.moduleSlug,
                        slug: this.lesson.slug,
                        rating
                    })
                }
                if (rating) {
                    this.$emit('showCommentForm', !!rating)
                }
            } catch (e) {
                console.error(e.message);
            }


        }
    }
};
